import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

export default function AboutSection() {
  return (
    <section className="bg-cream">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <Reveal>
              <SectionHeading
                eyebrow="關於許文彰"
                title="從工程思維、企業管理，到人才成長。"
              />
              <div className="mt-6 space-y-5 text-base leading-[1.85] text-ink-soft reading-width">
                <p>
                  我是許文彰。多年來，我從工程、企業管理、問題診斷、流程改善到人才培育，
                  一直在做同一件事：找出真正影響結果的關鍵，再把問題轉成可以實際改善的行動。
                </p>
                <p>
                  在企業與人的工作現場，我越來越清楚看見：很多人不是不知道，而是做不到；
                  不是沒有目標，而是缺少一套能持續走下去的方法。這也成為我後來整理
                  「幸福人才養成系統」的重要起點。
                </p>
              </div>
              <div className="mt-8">
                <Button to="/about" variant="outline" icon="ri-arrow-right-line">
                  認識許文彰
                </Button>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={100}>
              <div className="rounded-card bg-white border border-line p-8">
                <p className="text-5xl md:text-6xl font-bold text-primary">
                  30<span className="text-gold">+</span>
                </p>
                <p className="mt-3 text-sm text-ink-soft">
                  年｜相關企業管理／實務經驗
                </p>
                <div className="mt-6 h-px bg-line"></div>
                <p className="mt-5 text-sm text-ink-soft leading-[1.8]">
                  從解決企業的問題，到陪人找到真正能持續的改變。
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}